<template>
  <div>
    <p v-if="props.isTitleShown" class="text-sm mb-2" :class="receivePromoError ? 'text-scarlet-50' : 'text-black-50'">
      {{ $t('promo.input_title') }}
    </p>
    <div class="input-container flex" :class="props.inputContainerClass">
      <div :class="twMerge('flex-1', props.inputBoxClass)">
        <etg-input
          v-model:value="promoCode"
          :status="receivePromoError ? 'error' : undefined"
          class="w-full"
          :placeholder="$t('promo.placeholder')"
          clearable
          size="small"
          :autofocus="false"
          enter-key-hint="go"
          passively-activated
          @keyup.enter="onReceivePromoConfirm"
        >
          <template #prefix>
            <svg-icon name="sale" class="size-4 mr-2" />
          </template>
        </etg-input>
        <div v-show="receivePromoError" class="mt-1 text-sm text-scarlet-50">{{ receivePromoError }}</div>
      </div>
      <etg-button
        type="primary"
        :class="twMerge('self-baseline', props.claimBtnClass)"
        :disabled="isReceiveBtnDisabled"
        :loading="isReceiveBtnLoading"
        @click="onReceivePromoConfirm"
      >
        {{ $t('promo.claim') }}
      </etg-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { twMerge } from 'tailwind-merge'

import EtgInput from '@/components/form/etg-input.vue'

import { QueryStringKeys } from '@/constants/commons'

interface Props {
  isTitleShown?: boolean
  inputBoxClass?: string
  inputContainerClass?: string
  claimBtnClass?: string
  onReceivePromoSuccess?: UseReceivePromoCodeExecutorParams['onSuccess']
}

const props = withDefaults(defineProps<Props>(), { isTitleShown: false })

const route = useRoute()

const queryPromoCode = computed(() => route.query[QueryStringKeys.PROMO_CODE] as string)
const isAutoRedeemPromoCode = computed(() => !!queryPromoCode.value && route.query[QueryStringKeys.PROMO_AUTO_REDEEM] === '1')

const {
  isLoading: isReceivePromoLoading,
  promoCode,
  receivePromoError,
  executeReceivePromo,
} = useReceivePromoCode({ defaultPromoCode: queryPromoCode.value })

const isReceiveBtnLoading = computed(() => isReceivePromoLoading.value || (import.meta.server && isAutoRedeemPromoCode.value))
const isReceiveBtnDisabled = computed(() => !promoCode.value)

onMounted(() => {
  if (isAutoRedeemPromoCode.value) {
    onReceivePromoConfirm()
  }
})

function onReceivePromoConfirm() {
  if (!promoCode.value) {
    return
  }
  executeReceivePromo({ onSuccess: props.onReceivePromoSuccess })
}
</script>
